var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"在线客服"}},[_c('cell',{attrs:{"note":"sw39293","url":"#"}},[_vm._v("微信客服")]),_c('cell',{attrs:{"note":"39344833","url":"#"}},[_vm._v("客服QQ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }